import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// components
import { ReduxEntitySelect, ReduxInput, ReduxSwitch } from 'components/FormElements'
// graphql
import { COMPANY_RISK_RESPONSE_TYPES_QUERY } from 'graphql/company/queries'
// types
import { Forms } from 'constants/forms'
import { IResponseTypesSet } from 'types/graphql'
// utils
import get from 'lodash/get'
import { required } from 'utils/validators'

const selector = formValueSelector(Forms.PROPERTY_EDIT_FORM)

const PicklistSettings: React.FC = () => {
  const responseType = useSelector((state) => selector(state, 'responseType') || false)

  const getFieldsOptions = ({ data }) =>
    get<IResponseTypesSet[]>(data, 'getCompanyRiskResponseTypes.responseTypesSets', []).map(({ id, options }) => ({
      value: id,
      label: options.map((item) => item.label).join(', ')
    }))

  return (
    <>
      {responseType && <ReduxSwitch name='hideName' label='Hide Label' reverse />}
      <ReduxSwitch name='responseType' label='Use Response Type' reverse />
      {responseType && (
        <>
          <ReduxEntitySelect
            validate={[required]}
            name='responseTypeId'
            label='Response Types Set'
            getOptions={getFieldsOptions}
            query={COMPANY_RISK_RESPONSE_TYPES_QUERY}
          />
          <ReduxInput name='weight' label='Weight' type='number' />
        </>
      )}
    </>
  )
}

export default PicklistSettings
